import React, { Component } from 'react'
import { observer } from 'mobx-react'
import store from './store'
import style from '../style.module.less'

@observer
export default class extends Component {
  render() {
    const { unreadLetterCount, toChat } = store
    return (
      <a className={style.chat} onClick={toChat}>
        {unreadLetterCount > 0 && (
          <span className={style.unRead}>{unreadLetterCount}</span>
        )}
      </a>
    )
  }
}
